import { createSlice } from '@reduxjs/toolkit';

export interface ChannelsStateType {}

const initialState: ChannelsStateType = {};

export const ChannelsState = createSlice({
  name: 'ChannelsState',
  initialState,
  reducers: {},
});
